import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import FestivalView from "@/components/FestivalView";

// Fetches the currently-active festival wish for this page and shows it once per session.
export default function FestivalBanner() {
  const { pathname } = useLocation();
  const [fest, setFest] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get(`/festivals/active?page=${encodeURIComponent(pathname)}`)
      .then((r) => setFest(r.data))
      .catch(() => setFest(null));
  }, [pathname]);

  useEffect(() => {
    if (fest) setHidden(sessionStorage.getItem(`mc_fest_${fest.id}`) === "1");
  }, [fest]);

  if (!fest || hidden) return null;
  return (
    <FestivalView
      fest={fest}
      onClose={() => { sessionStorage.setItem(`mc_fest_${fest.id}`, "1"); setHidden(true); }}
    />
  );
}
